import Navigation from 'components/shared/Navigation/Navigation'
import React from 'react'
import { Menu } from 'semantic-ui-react'

export default class NavigationColumns extends React.Component {
  render() {
    const { items, dark } = this.props

    const menuItems = items.map((item) => (
      <Navigation
        render="children"
        as="submenu-categories"
        node={item.name.replace('/node/', '')}
        key={item.key}
      />
    ))

    // TODO: fix the four column alignment (CSS3) or replace by other column render logic
    return (
      <Menu
        color="black"
        secondary
        className="four columns"
        size="large"
        fluid
        vertical
        inverted={dark}>
        {menuItems}
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationColumns.jsx